import { render, staticRenderFns } from "./_Wallet.vue?vue&type=template&id=1a3a6d22&scoped=true"
import script from "./_Wallet.vue?vue&type=script&lang=js"
export * from "./_Wallet.vue?vue&type=script&lang=js"
import style0 from "./_Wallet.vue?vue&type=style&index=0&id=1a3a6d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3a6d22",
  null
  
)

export default component.exports